import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import configBackground from '../wob-background-menu'
import fontSizeMenu from '../font-size-menu'
import BaseGaugeConfig from '../base-gauge-config'
import {SCORECARDS} from '../../../components/sections'
import {metricish} from '../../../scorecards/scorecard-node'
import config from '../../../components/config'
import _ from 'lodash'
import constants from '../../../components/constants'
import i18n from '../../../components/i18n'

var LinearGaugeConfig = BaseGaugeConfig.extend({

	/** @type {LinearGauge} */
	model: null,

	initialize: function (opt) {
		this.canvas = opt.canvas
		BootslideMenu.prototype.initialize.apply(this, arguments)
	},

	typeSpecificTargets: function (hasTemplate) {
		let target = []

		// if this is a template copy node, there's nothing to configure
		if (hasTemplate) {
			return [ ]
		}

		target.push(this.createSetNameOption())
		target.push(this.createDataSourceOption())
		// #58603 for the scorecards section, thresholds are defined on the
		// scorecard node, not on the dashboard
		if (this.model.section() != SCORECARDS) {
			target.push(this.createThresholdsOption())
		}
		target.push(fontSizeMenu(this.model.properties))
		target.push(configBackground(this.model.properties))
		target.push(this.createShowingOption())

		return target
	},

	createDataSourceOptionOptions: function() {
		let options = BaseGaugeConfig.prototype.createDataSourceOptionOptions.apply(this, arguments)
		options.dataSourceSelectorOptions.objectSelectorOptions = {
			testSelectedObject: testNotUnscored
		}
		return options
	}

})

/**
 * Verifies that the given domain object is not an unscored metric (#58607)
 */
function testNotUnscored(node) {
	if (!metricish(node)) {
		// #58849 prevent error when non-scorecard or non-metric is selected.
		// (`true` is not considered a valid response by formView.validate - it
		// expects test() to return either null/undefined or an error message)
		return
	}

	let scoringType = config.scoringType(node.scoringTypeId)
	// #50270 Don't allow selecting unscored or unscored text metrics
	let isUnscored =
		_.get(scoringType, 'standardScoringType') == constants.UNSCORED ||
		_.get(scoringType, 'kpiValueType') == constants.UNSCORED_TEXT
	if (isUnscored) {
		return i18n.get('dashboards.dashboard.linearGauge.notUnscored')
	}
}

export default LinearGaugeConfig
export { testNotUnscored }
LinearGaugeConfig.__filename__ = 'dashboards/widgets/linear-gauge/linear-gauge-config.js'
